'use client';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { JSection } from '@/components/ui/layout';
import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';
import TerraImage from './terra-image';

export default function Bounded() {
    const { t } = useTranslation('terra1-bounded');

    const contentList: {
        content: string;
        isBlod: boolean;
    }[][] = t('contents', { returnObjects: true }) as {
        content: string;
        isBlod: boolean;
    }[][];

    return (
        <JSection
            spacing="none"
            size="lg"
            padding="lg"
            className="mt-[80px] flex h-auto items-center justify-center sm:mt-[160px]"
        >
            <div className="flex w-full flex-col-reverse items-center justify-center gap-[32px] sm:flex-row sm:gap-[80px]">
                <div className="flex h-full w-full items-center justify-center sm:basis-1/2">
                    <div className="flex w-full flex-col gap-[16px] sm:gap-[24px]">
                        <h2
                            className={clsx('j-h2 w-full text-left text-white')}
                        >
                            {t('title')}
                        </h2>
                        <div
                            className={clsx(
                                'j-t1 flex flex-col gap-[20px] text-white',
                            )}
                        >
                            {contentList.map((selection, index) => {
                                return (
                                    <div key={'content-list-' + index}>
                                        {selection.map((content, index) => (
                                            <span
                                                key={'content-' + index}
                                                className={clsx('', {
                                                    'font-bold': content.isBlod,
                                                })}
                                            >
                                                {content.content}
                                            </span>
                                        ))}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="relative flex h-[326px] w-full sm:h-[640px] sm:basis-1/2">
                    <TerraImage
                        wrapperClassName="h-full w-full"
                        fill
                        style={{
                            height: '100%',
                            width: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center',
                        }}
                        src={getStaticAssetUrl(
                            '/terra1/joinai-terra-1-physical-boundaries-illustration.webp',
                        )}
                        alt={t('boundariesImageDescription')}
                        skeletonClassName="bg-[#17171C]"
                    />
                </div>
            </div>
        </JSection>
    );
}
